import ServiceHero from '@/components/sections/ServiceHero'

export default function GrowthHero() {
  return (
    <ServiceHero
      serviceName="Growth"
      titleLines={['Growth', 'That Compounds']}
      description="Data-driven strategy to find where your biggest bang for buck lives. We don't recommend the same playbook to every client — we analyse your business, your audience, and your funnel, then build a growth plan that actually fits."
    />
  )
}
